// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  Link as MuiLink,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import {
  RiLinkedinFill as LinkedInIcon,
  RiExternalLinkLine as OpenInNew,
  RiTwitterFill as TwitterIcon,
} from '@remixicon/react';

import { ConfidenceLogo } from '../Icons';

const useStyles = makeStyles(theme => {
  return createStyles({
    footer: {
      display: 'flex',
      width: 'calc(100% - 160px)',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '27px 0',
      borderTop: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.down('sm')]: {
        width: 'calc(100% - 32px)',
        flexDirection: 'column',
        gap: 32,
      },
    },
    footerLogo: {
      width: 32,
      height: 32,
    },
    footerLinks: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(4),
      flexWrap: 'wrap',
    },
    footerLink: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
    },
    footerIcon: {
      width: 24,
      height: 24,
    },
  });
});

const Links = {
  HOME: 'https://confidence.spotify.com',
  BLOG: 'https://confidence.spotify.com/blog',
  LINKEDIN: 'https://www.linkedin.com/showcase/spotify-r&d/LinkedIn',
  TWITTER: 'https://twitter.com/SpotifyEng',
};

export const Footer = () => {
  const classes = useStyles();

  return (
    <div className={classes.footer}>
      <MuiLink
        color="inherit"
        href={Links.HOME}
        target="_blank"
        className={classes.footerLink}
      >
        <ConfidenceLogo className={classes.footerLogo} color="currentColor" />
        <Typography variant="subtitle1">Confidence</Typography>
      </MuiLink>

      <div className={classes.footerLinks}>
        <MuiLink
          color="inherit"
          href={Links.BLOG}
          target="_blank"
          className={classes.footerLink}
        >
          <OpenInNew className={classes.footerIcon} />
          <Typography variant="subtitle1" style={{ minWidth: 43 }}>
            Blog
          </Typography>
        </MuiLink>
        <MuiLink
          color="inherit"
          href={Links.LINKEDIN}
          target="_blank"
          className={classes.footerLink}
        >
          <LinkedInIcon className={classes.footerIcon} />
          <Typography variant="subtitle1">LinkedIn</Typography>
        </MuiLink>
        <MuiLink
          color="inherit"
          href={Links.TWITTER}
          target="_blank"
          className={classes.footerLink}
        >
          <TwitterIcon className={classes.footerIcon} />
          <Typography variant="subtitle1">Twitter</Typography>
        </MuiLink>
      </div>
    </div>
  );
};
